var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content col-md-10"},[_c('ppe-form',{attrs:{"entityName":"User","title":"A. Votre compte","title-field":"{name}","sub-title":"Informations individuelles","schema":_vm.schema,"endpoint":this.getApiUrl()}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }